<template>
  <v-row>
    <!--2 column form-->
    <!--col 1-->
    <v-col cols="6" md="4" offset-sm="1">
      <!--column inner-->
      Документ, подтверждающий право собственности (пользования) на помещение/земельный участок
      <file-form fileType="802740000" @transferData="setFile" :income="files['802740000']"></file-form>

      Документ, удостоверяющий личность физического лица (2-3 стр. и страница с пропиской)
      <file-form fileType="802740001" @transferData="setFile" :income="files['802740001']"></file-form>

      ИНН (при наличии)
      <file-form fileType="802740002" @transferData="setFile" :income="files['802740002']"></file-form>

      Акт проверки и допуска в эксплуатацию измерительного комплекса электроэнергии (при наличии прибора учета)
      <file-form fileType="802740004" @transferData="setFile" :income="files['802740004']"></file-form>

      <!--end of column inner-->
    </v-col>
    <!--col 2-->
    <v-col cols="6" md="4" offset-sm="1">
      <!--column inner-->
      Акт об осуществлении технологического присоединения или акт разграничения балансовой принадлежности
      <file-form fileType="802740005" @transferData="setFile" :income="files['802740005']"></file-form>

      Для энергопринимающих устройств с суммарной мощностью более 15 кВт – акт осмотра энергоустановки и разрешение на
      допуск энергоустановки в эксплуатацию, выдаваемые органами Ростехнадзора
      <file-form fileType="802740003" @transferData="setFile" :income="files['802740003']"></file-form>

      <div>
        <v-col class="information-container">
          <p class="mt-0 mb-2">
            Договор об осуществлении технологического присоединения
            с ОАО "Сетевая компания"
          </p>
          <!-- <p class="mt-0 mb-2">Номер: {{income.dogovorTp || 'номер не определен'}}</p> -->
          <p class="mt-0 mb-2">Номер: {{dogovorTp}}</p>
          <!-- <p class="mt-0 mb-2">Дата: {{new Date(income.dogovorDate).toLocaleDateString()}}</p> -->
          <p class="mt-0 mb-2">Дата: {{new Date(dogovorDate).toLocaleDateString()}}</p>
        </v-col>

        <v-col class="sub-information-container">
          <p
            class="mt-0 mb-2"
          >Максимальный размер файла- 20 Мб Допустимые форматы файлов: pdf, jpg, jpeg, bmp, gif</p>
        </v-col>
      </div>

      <!--end of column inner-->
    </v-col>
  </v-row>
</template>

<script>
  import FileForm from "../components/partial/FileForm";
  import {mapState} from 'vuex';

  export default {
    props: ["income", 'formData'],
    components: {
      FileForm
    },
    data: () => ({
      // DATA
      files: {
        "802740000": null,
        "802740001": null,
        "802740002": null,
        "802740004": null,
        "802740005": null,
        "802740003": null
      },
      edit: false
    }),
    computed: {
      dataIsValid() {
        return (
          this.files["802740000"] !== null &&
          this.files["802740001"] !== null &&
          //  && this.files['802740002'] !== null // ИНН не обязателен
          this.files["802740003"] !== null &&
          this.files["802740004"] !== null &&
          this.files["802740005"] !== null
        );
      },
      ...mapState({
        dogovorDate: state => state.statements.agreementConclusionData[0].data.dogovorDate,
        dogovorTp: state => state.statements.agreementConclusionData[0].data.dogovorTp
      })
    },
    methods: {
      transferData() {
        // DATA
        this.$emit("transfer", {
          files: this.files
        });
      },
      setFile(payload) {
        this.files[payload.fileType] = payload;
      },
    },
    created() {
      if (this.income && this.income.files) {
        let keys = Object.keys(this.income.files);
        keys.forEach(key => {
          this.files[key] = this.income.files[key];
        });
      }
      if (window.location.href.indexOf("type=edit") > -1) {
        this.edit = true;
      }

      // if (!this.dogovorDate || !this.dogovorTp) {
      //
      // }


    },
    mounted () {
      if (this.formData.files) {
        this.formData.email = this.income.email
        this.formData.okooffice = this.income.okooffice
        this.email = this.formData.email
        this.okooffice = this.formData.okooffice
        let keys = Object.keys(this.formData.files);

        keys.forEach(key => {
          if(this.formData.files[key] && this.formData.files[key].fileType){
            this.files[this.formData.files[key].fileType] = this.formData.files[key];
          }
        });
      }
    },
    watch: {
      dataIsValid: {
        immediate: true,
        handler: function(value) {
          this.$emit("lockFwdBtn", !value);
        }
      }
    }
  };
</script>

<style lang="scss">
  .information-container {
    margin-top: 20px;
    border: 1px solid #ff721c;
    padding: 40px 60px 40px 60px;
  }

  .sub-information-container {
    margin-top: 20px;
    padding-left: 0;
    border-top: 4px solid lightgray;
  }
</style>
